import { faGear as faGearLight } from '@fortawesome/pro-light-svg-icons';
import { faGear, faGears } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';

import { UpdateGeneralSettingsForm } from '~/components/forms/GeneralSettingsForm';
import { Breadcrumbs } from '~/components/molecules/Breadcrumbs';
import { Heading } from '~/components/molecules/Heading';
import { AppBreadcrumbs } from '~/components/organisms/Breadcrumbs';

export type IAppGeneralSettingsPageProps = {
  appId: string;
};

export const AppGeneralSettingsPage: React.FC<IAppGeneralSettingsPageProps> = (
  props,
) => {
  const { appId } = props;
  const { t } = useTranslation();
  const parentUrl = `/apps/${appId}/settings`;

  return (
    <>
      <Helmet>
        <title>{t('AppGeneralSettingsPage.seo.title')}</title>
      </Helmet>

      <AppBreadcrumbs appId={appId}>
        <Breadcrumbs.Action href={parentUrl}>
          <FontAwesomeIcon icon={faGears} />
          {t('common.settings')}
        </Breadcrumbs.Action>
        <Breadcrumbs.Text current>
          <FontAwesomeIcon icon={faGear} />
          {t('AppGeneralSettingsPage.title')}
        </Breadcrumbs.Text>
      </AppBreadcrumbs>

      <Heading
        icon={<FontAwesomeIcon icon={faGearLight} />}
        title={t('AppGeneralSettingsPage.title')}
        subtitle={t('AppGeneralSettingsPage.subtitle')}
        previousUrl={parentUrl}
      />

      <UpdateGeneralSettingsForm appId={appId} />
    </>
  );
};
